export default [
    {
        header: [
            [
                { text: 'Imagine being part of an' },
                { text: 'organization where human' },
                { text: 'connection underlies' },
                { text: 'everything we do.' }
            ],
            [
                { seen: false, text: 'Imagine' },
                { seen: false, text: 'being part of an' },
                { seen: false, text: 'organization where' },
                { seen: false, text: 'human connection' },
                { seen: false, text: 'underlies everything' },
                { seen: false, text: 'we do.' }
            ]
        ],
        subheader: [
            { text: 'It&rsquo;s a place where we&rsquo;re focused on helping our clients, colleagues and communities thrive. That&rsquo;s our purpose, or as we like to say, our purple.' }
        ]
    },
    {
        header: [
            [
                { text: 'To begin your journey, please provide us with your first name:' }
            ]
        ],
        subheader: [
            { text : 'I am:' }
        ]
    }
]
